import { PessoaDTO } from './pessoa.dto';

export class PessoaFisicaDTO {

    pessoaDTO: PessoaDTO = void (0);
    cdPessoa: number;
    cdEstadoRg: number;
    nrCpf: string;
    nrRg: string;
    nrCnh: string;
    dtNascimento: Date;
    dtValidadeCnh: Date;
    sgOrgaoRg: string;
    tpSexo: number;
    tpCategoriaHabilitacao: number;
    constructor(
        pessoaDTO?: PessoaDTO,
        cdPessoa?: number,
        cdEstadoRg?: number,
        nrCpf?: string,
        nrRg?: string,
        nrCnh?: string,
        dtNascimento?: Date,
        dtValidadeCnh?: Date,
        sgOrgaoRg?: string,
        tpSexo?: number,
        tpCategoriaHabilitacao?: number
    ) {
        this.pessoaDTO = pessoaDTO;
        this.cdPessoa = cdPessoa;
        this.cdEstadoRg = cdEstadoRg;
        this.nrCpf = nrCpf;
        this.nrRg = nrRg;
        this.nrCnh = nrCnh;
        this.dtNascimento = dtNascimento;
        this.dtValidadeCnh = dtValidadeCnh;
        this.sgOrgaoRg = sgOrgaoRg;
        this.tpSexo = tpSexo;
        this.tpCategoriaHabilitacao = tpCategoriaHabilitacao;
    }
}